import React from 'react';

/**
 * Decorative map for design previews (not a live Leaflet instance).
 */
const PreviewRouteMap = () => (
  <div className="dp-map" aria-hidden="true">
    <svg viewBox="0 0 640 200" className="dp-map__svg">
      <rect width="640" height="200" className="dp-map__bg" />
      <polyline
        points="80,150 220,70 480,110"
        className="dp-map__route"
        fill="none"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="80" cy="150" r="8" className="dp-map__pin" />
      <circle cx="220" cy="70" r="8" className="dp-map__pin" />
      <circle cx="480" cy="110" r="8" className="dp-map__pin" />
      <text x="92" y="148" className="dp-map__label">
        Depot · TN
      </text>
      <text x="232" y="66" className="dp-map__label">
        Pickup · MI
      </text>
      <text x="492" y="106" className="dp-map__label">
        Delivery · NC
      </text>
    </svg>
  </div>
);

export default PreviewRouteMap;
